<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M11.992,23.253c-0.696,0-1.389-0.183-2.003-0.529c-0.708-0.399-1.265-0.978-1.628-1.688
		c-0.367,0.108-0.747,0.162-1.134,0.162c-1.106,0-2.176-0.458-2.933-1.257c-1.064-1.122-1.448-2.746-1.018-4.219
		c-0.888-0.508-1.558-1.308-1.905-2.285c-0.384-1.08-0.324-2.245,0.168-3.28c0.382-0.802,0.978-1.446,1.737-1.879
		C2.846,6.806,3.23,5.182,4.294,4.06c0.758-0.798,1.827-1.256,2.933-1.256c0.388,0,0.769,0.055,1.137,0.163
		c0.52-1.001,1.446-1.761,2.534-2.065c0.359-0.1,0.729-0.151,1.099-0.151c1.548,0,2.94,0.859,3.638,2.215
		c0.367-0.108,0.748-0.163,1.135-0.163c1.106,0,2.175,0.458,2.932,1.257c1.063,1.12,1.448,2.741,1.021,4.213
		c1.332,0.753,2.166,2.183,2.151,3.731c0.015,1.541-0.82,2.97-2.151,3.723c0.427,1.472,0.042,3.094-1.021,4.214
		c-0.758,0.799-1.827,1.257-2.933,1.257l0,0c-0.387,0-0.768-0.055-1.136-0.163c-0.52,1.001-1.446,1.761-2.534,2.064
		C12.736,23.202,12.364,23.253,11.992,23.253z M8.78,19.309c0.101,0,0.2,0.02,0.294,0.06c0.211,0.09,0.367,0.268,0.429,0.488
		c0.186,0.667,0.621,1.221,1.224,1.561c0.389,0.219,0.827,0.335,1.268,0.335c0.235,0,0.471-0.032,0.701-0.097
		c0.867-0.242,1.557-0.932,1.799-1.799c0.061-0.22,0.217-0.398,0.428-0.488c0.094-0.04,0.193-0.06,0.294-0.06
		c0.123,0,0.246,0.031,0.355,0.089c0.367,0.198,0.781,0.302,1.198,0.302c0.696,0,1.367-0.288,1.843-0.79
		c0.823-0.867,1.017-2.167,0.484-3.236c-0.096-0.193-0.105-0.418-0.024-0.618c0.083-0.201,0.247-0.356,0.451-0.426
		c1.119-0.384,1.862-1.437,1.85-2.62c0.012-1.199-0.731-2.252-1.85-2.637c-0.204-0.07-0.369-0.225-0.45-0.425
		C18.991,8.747,19,8.522,19.096,8.329c0.534-1.069,0.34-2.369-0.483-3.235c-0.476-0.502-1.147-0.789-1.843-0.789
		c-0.417,0-0.832,0.104-1.199,0.301c-0.109,0.059-0.232,0.09-0.355,0.09c-0.102,0-0.201-0.02-0.294-0.06
		c-0.211-0.09-0.367-0.268-0.428-0.489c-0.312-1.115-1.338-1.894-2.497-1.894c-0.234,0-0.468,0.032-0.695,0.095
		c-0.867,0.242-1.557,0.931-1.799,1.799C9.441,4.367,9.285,4.545,9.074,4.635c-0.093,0.04-0.192,0.06-0.294,0.06
		c-0.124,0-0.246-0.031-0.355-0.09C8.058,4.408,7.644,4.304,7.226,4.304c-0.696,0-1.368,0.288-1.844,0.789
		C4.56,5.96,4.366,7.26,4.9,8.329c0.096,0.192,0.105,0.417,0.025,0.616C4.845,9.143,4.683,9.298,4.48,9.37
		c-0.703,0.25-1.266,0.758-1.587,1.432s-0.359,1.431-0.109,2.134c0.282,0.795,0.901,1.413,1.696,1.696
		c0.202,0.072,0.364,0.227,0.444,0.427c0.08,0.199,0.071,0.423-0.025,0.615c-0.534,1.069-0.34,2.369,0.482,3.236
		c0.476,0.502,1.149,0.79,1.844,0.79c0.417,0,0.832-0.104,1.198-0.302C8.533,19.34,8.656,19.309,8.78,19.309z"/>
	<path d="M8.623,16.502c-0.2,0-0.389-0.078-0.53-0.22c-0.292-0.292-0.292-0.768,0-1.061l7.5-7.5c0.142-0.142,0.33-0.22,0.53-0.22
		c0.2,0,0.389,0.078,0.53,0.22c0.142,0.141,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53l-7.5,7.5
		C9.012,16.424,8.823,16.502,8.623,16.502z"/>
	<path d="M9.373,11.252c-1.241,0-2.25-1.009-2.25-2.25s1.009-2.25,2.25-2.25s2.25,1.009,2.25,2.25S10.614,11.252,9.373,11.252z
		 M9.373,8.252c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S9.787,8.252,9.373,8.252z"/>
	<path d="M15.373,17.252c-1.241,0-2.25-1.009-2.25-2.25s1.009-2.25,2.25-2.25s2.25,1.009,2.25,2.25S16.614,17.252,15.373,17.252z
		 M15.373,14.252c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S15.787,14.252,15.373,14.252z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'discount-bubble',
    },
    name: {
      type: String,
      required: false,
      default: 'DiscountBubble',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>